import React, {FC} from 'react';

import {sendDesktopAnalyticsPerSession} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Icon} from '@optimaxdev/icons';
import {connect} from 'react-redux';

import {CHECKOUT_PAYMENT_STEP} from 'constants/analytics/events/checkout';
import {STEPS} from 'desktop/pages/checkout/constants/checkout';
import {getCurrentStep} from 'desktop/pages/checkout/store/selectors/currentStep/currentStep';
import {ApplicationStoreType} from 'desktop/store';

import {PAYMENTS} from '../../constants/paymentStep';

import * as CardsIcon from '../../img/cards.svg';
import {getIsSelectedByKey} from '../../store/selectors/paymentStep/paymentStep';
import {PaymentWrapperConnected} from '../paymentWrapper/paymentWrapper';

import {PaymentPrimerCreditCardConnected} from './paymentPrimerCreditCard';

import s from './primerWrapper.scss';

type PropsType = {
    isSelected: boolean;
    currentStep: string;
};

/**
 * wrapper for primer payment
 */
export const PrimerWrapper: FC<PropsType> = ({currentStep, isSelected}) => {
    if (currentStep !== STEPS.PAYMENT_STEP) return null;

    const sendAnalytics = () => {
        sendDesktopAnalyticsPerSession({
            event: CHECKOUT_PAYMENT_STEP,
            label: {
                message: 'Credit Card - Card image clicked',
                method: 'Payment',
            },
        });
    };

    return (
        <PaymentWrapperConnected
            rightSideIcon={
                <Icon
                    className={s.cards}
                    height={23}
                    icon={CardsIcon}
                    label="CardsIcon"
                    onClick={sendAnalytics}
                    width={245}
                />
            }
            title={
                <div className={s.title}>
                    <span>Credit card</span>
                </div>
            }
            code={PAYMENTS.METHOD_PRIMER}
            isSelected={isSelected}
        >
            <PaymentPrimerCreditCardConnected />
        </PaymentWrapperConnected>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux stores
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    currentStep: getCurrentStep(store),
    isSelected: getIsSelectedByKey(store, PAYMENTS.METHOD_PRIMER),
});

export const PrimerWrapperConnected = connect(mapStateToProps)(PrimerWrapper);
